import { RouteParam } from ".";

const DebugGlitchtip = () => {
  throw new Error("Test GlitchTip error!");
};

const debug_routes: RouteParam[] = [
  {
    isPrivate: false,
    fullScreen: true,
    exact: true,
    path: "/debug-glitchtip",
    component: DebugGlitchtip,
  },
];

export default debug_routes;
